export const MAX_CACHE_AGE = 15 * 1000 * 60; // 15 minutes

export const FIELDCACHE_SET_FIELDS = 'FIELDCACHE_SET_FIELDS';
